/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getConfigResponse = zod.object({
  "googleMaps": zod.object({
  "apiKey": zod.string(),
  "mapId": zod.string()
}),
  "fsmSyncWindow": zod.object({
  "minDays": zod.number(),
  "maxDays": zod.number(),
  "defaultDays": zod.number()
}),
  "organizationTimeZone": zod.object({
  "supportedIds": zod.array(zod.string()),
  "defaultId": zod.string()
}),
  "funding": zod.object({
  "clearingWindowBusinessDays": zod.number()
})
})

